(function($) {
    $('.case-slider').slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1500,
        dots: true,
        arrows: false,
        pauseOnHover: true,
    });
    $('.case-slider2').slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1500,
        dots: false,
        arrows: false,
        pauseOnHover: true,
    });
})($);